export class UrlTokenParser {
    private readonly replacementParts: {
        originWithoutPortUS: string;
        originWithoutPortCanada: string;
    };

    constructor() {
        const { origin, port, host } = document.location;
        const originWithoutPort = port
            ? origin.replace(`:${port}`, '')
            : origin;

        const isProd = [
            'www.siriusxm.com',
            'can.siriusxm.com',
            'care.siriusxm.com',
            'care.siriusxm.ca',
        ].includes(host);

        const isPerf = ['ffcare.siriusxm.com', 'care-qa.siriusxm.ca'].includes(
            host,
        );

        const isUat = host.startsWith('uat.') || host.startsWith('can.uat.');
        const isLocalhost = [
            'localhost.siriusxm.com',
            'can.localhost.siriusxm.com',
            'localhost.siriusxm.ca',
        ].includes(host.replace(`:${port}`, ''));

        let originWithoutPortUS;
        let originWithoutPortCanada;
        if (isProd) {
            originWithoutPortUS = 'care.siriusxm.com';
            originWithoutPortCanada = 'care.siriusxm.ca';
        } else if (isPerf) {
            originWithoutPortUS = 'ffcare.siriusxm.com';
            originWithoutPortCanada = 'care-qa.siriusxm.ca';
        } else if (isUat) {
            if (host.startsWith('uatca.')) {
                originWithoutPortUS = originWithoutPort.replace(
                    /uatca\./,
                    'uatwww.',
                );
                originWithoutPortCanada = originWithoutPort;
            } else {
                originWithoutPortUS = originWithoutPort;
                originWithoutPortCanada = originWithoutPort.replace(
                    '://uatwww.',
                    '://uatca.',
                );
            }
        } else if (isLocalhost) {
            if (host.startsWith('can.')) {
                originWithoutPortUS = originWithoutPort.replace(/can\./, '');
                originWithoutPortCanada = originWithoutPort;
            } else if (host.indexOf('siriusxm.ca') != -1) {
                originWithoutPortUS = originWithoutPort.replace(/\.ca/, '.com');
                originWithoutPortCanada = originWithoutPort;
            } else {
                originWithoutPortUS = originWithoutPort;
                originWithoutPortCanada = originWithoutPort.replace(
                    '://',
                    '://can.',
                );
            }
        } else if (host.startsWith('can--')) {
            originWithoutPortUS = originWithoutPort.replace(/can--/, '');
            originWithoutPortCanada = originWithoutPort;
        } else if (host.startsWith('variant')) {
            originWithoutPortUS = originWithoutPort;
            originWithoutPortCanada = originWithoutPort;
        } else {
            originWithoutPortUS = originWithoutPort;
            originWithoutPortCanada = originWithoutPort.replace(
                '://',
                '://can--',
            );
        }

        this.replacementParts = {
            originWithoutPortUS,
            originWithoutPortCanada,
        };
    }

    replaceToken(url: string, countryCode: 'us' | 'ca'): string {
        const { originWithoutPortUS, originWithoutPortCanada } =
            this.replacementParts;
        const originWithoutPort =
            countryCode == 'us' ? originWithoutPortUS : originWithoutPortCanada;
        return url.replace('{originWithoutPort}', originWithoutPort);
    }
}
